import Cookies from "js-cookie";

const TokenKey = "user_token";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function getUserInfo() {
  if (Cookies.get("user_info")) {
    return JSON.parse(Cookies.get("user_info"));
  } else {
    return null;
  }
}

export function setUserInfo(info) {
  return Cookies.set("user_info", info);
}

export function removeToken() {
  Cookies.remove(TokenKey);
  Cookies.remove('user_info');
  return true;
}
